import { render, staticRenderFns } from "./NewProjectIssue.vue?vue&type=template&id=3be946a3&scoped=true"
import script from "./NewProjectIssue.vue?vue&type=script&lang=js"
export * from "./NewProjectIssue.vue?vue&type=script&lang=js"
import style0 from "./NewProjectIssue.vue?vue&type=style&index=0&id=3be946a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be946a3",
  null
  
)

export default component.exports